import { createContext, RefObject } from 'react';
import { NavigationProps } from '@interfaces/navigation';
import { ScrollView } from 'react-native';

export interface MachinesContextProps extends Pick<NavigationProps, 'lg'> {
  isGlobalMachineList: boolean;
  onBack: () => void;
}

export const MachinesContext = createContext<MachinesContextProps>(null!);
